export default __webpack_public_path__ + "static/media/header-carbon-video.55c35e04.mp4";